import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@models/responses/api-response.model';
import {
  N0BookingVerificationRequest,
  N0BookingVerificationStatusResponse,
  N0CompleteBookingVerificationResponse,
  N0VerificationResponse,
  VerifyRequest,
} from '@models/sms-validation.model';
import { EnvironmentService } from '@services/environment-service/environment.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class VerificationService {
  private static readonly CONTROLLER_ROOT = 'v1/verification';
  private static readonly BOOKING_ROOT = `${VerificationService.CONTROLLER_ROOT}/booking`;

  constructor(private http: HttpClient) {}

  getBookingVerificationStatus(): Observable<
    ApiResponse<N0BookingVerificationStatusResponse>
  > {
    return this.http.get<ApiResponse<N0BookingVerificationStatusResponse>>(
      `${EnvironmentService.environment.apiBaseUrl}${VerificationService.BOOKING_ROOT}/status`,
    );
  }

  initBookingVerification(
    request: N0BookingVerificationRequest,
  ): Observable<ApiResponse<N0VerificationResponse>> {
    return this.http.post<ApiResponse<N0VerificationResponse>>(
      `${EnvironmentService.environment.apiBaseUrl}${VerificationService.BOOKING_ROOT}`,
      request,
    );
  }

  completeBookingVerification(
    request: VerifyRequest,
  ): Observable<ApiResponse<N0CompleteBookingVerificationResponse>> {
    return this.http.post<ApiResponse<N0CompleteBookingVerificationResponse>>(
      `${EnvironmentService.environment.apiBaseUrl}${VerificationService.BOOKING_ROOT}/verify`,
      request,
    );
  }
}
